import {Component, Input} from '@angular/core';
import {EventType} from '../shared/webhook-subscription.model';

@Component({
  selector: 'app-webhook-event-type',
  templateUrl: './webhook-event-type.component.html',
  styleUrls: ['./webhook-event-type.component.scss']
})
export class WebhookEventTypeComponent {

  @Input()
  public type: EventType;

  public EventType = EventType;

}
